
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teachers/programmes/[programmeSlug]/units",
      function () {
        return require("private-next-pages/teachers/programmes/[programmeSlug]/units.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/teachers/programmes/[programmeSlug]/units"])
      });
    }
  